// Constants
import { MODAL_CONSTS } from '../../const/modal-const'

// Modals
import EventSchedulingViewScheduleModal from '../../components/events/forms/scheduling/components/EventSchedulingViewScheduleModal'
import UserProfileHorseTabAddHorse from '../../components/home/modals/UserProfileHorseTabAddHorse'
import ScoringModal from '../../components/modals/ScoringModal'
import ShareDocumentModal from '../../components/modals/ShareDocumentmodal'
import SignDocumentModal from '../../components/modals/SignDocumentModal'
import ViewModal from '../../components/modals/ViewModal'
import ExhibitorScratchConfirmModal from '../../pages/organizer/exhibitorProfile/modal/ExhibitorScratchConfirmModal'

// Organizer
import SendEmailModal from '../../components/events/forms/send-notifications/SendEmailModal'
import SuccessModal from '../../components/events/forms/send-notifications/SuccessModal'
import UserSearchModal from '../../components/events/forms/send-notifications/UserSearchModal'
import UpdateDisciplineModal from '../../components/modals/UpdateDisciplineModal'
import ManageEventModal from '../../pages/organizer/manage/common/modals/ManageEventModal'

// Common
import EventDetailViewComponentSpectatorTicketsModal from '../../components/events/views/details/modals/EventDetailViewComponentSpectatorTicketsModal'
import UserProfileTeamTabAddTeamMember from '../../components/home/modals/UserProfileTeamTabAddTeamMember'
import BillDetailsModal from '../../components/modals/BillDetailsModal'
import ForgotPassword from '../../components/modals/Forgotpassword'
import HorseTeamMemberRoleChangeConfirmation from '../../components/modals/HorseTeamMemberRoleChangeConfirmation'
import LineageHorseAdd from '../../components/modals/LineageHorseAdd'
import ListRemoveModal from '../../components/modals/ListRemoveModal'
import ReviewAnnex from '../../components/modals/ReviewAnnex'
import UploadEventImagesModal from '../../components/modals/UploadEventImagesModal'
import ProfileLegalClauseManageMembershipModal from '../../components/user/views/profile/modals/ProfileLegalClauseManageMembershipModal'
import ProfileLegalClauseMembershipModal from '../../components/user/views/profile/modals/ProfileLegalClauseMembershipModal '
import ProfileLegalClauseModal from '../../components/user/views/profile/modals/ProfileLegalClauseModal'
import TicketsDistributionModal from '../../pages/myEvent/modal/TicketsDistributionModal'
import { CloseEventConfirmationModal } from '../../pages/organizer/manage/common/modals/CloseEventConfirmationModal'

import { useLocation } from 'react-router'
import VideoPlayer from '../../components/common/players/VideoPlayer'
import { AddNewHorseModal } from '../../components/home/modals/AddNewHorseModal'
import { AddNewTeamMemberModal } from '../../components/home/modals/AddNewTeamMemberModal'
import { AddNewUserModal } from '../../components/home/modals/AddNewUserModal'
import RegistrationTeamTabModal from '../../components/home/modals/RegistrationTeamTabModal'
import AccountPrivacyInformation from '../../components/modals/AccountPrivacyInformation'
import AddCertificateModal from '../../components/modals/AddCertificateModal'
import { AddScoreCardModal } from '../../components/modals/AddScoreCardModal'
import { AddTeamMemberToPaperworkStep1 } from '../../components/modals/AddTeamMemberToPaperworkStep1'
import { AddTeamMemberToPaperworkStep2 } from '../../components/modals/AddTeamMemberToPaperworkStep2'
import { AiRuleBookModal } from '../../components/modals/AiRuleBookModal'
import AutoAssignModal from '../../components/modals/AutoAssignModal'
import { BulkAdd } from '../../components/modals/BulkAdd'
import { ClassMore } from '../../components/modals/ClassMore'
import { ConfirmProfileDetails } from '../../components/modals/ConfirmProfileDetails'
import { ConfirmRemoveDraftEventModal } from '../../components/modals/ConfirmRemoveDraftEventModal'
import { ConfirmScratchFullEntryModal } from '../../components/modals/ConfirmScratchFullEntryModal'
import { CreateNewTeamMemberPaperworkModal } from '../../components/modals/CreateNewTeamMemberPaperworkModal'
import { CreateRiderProfileStepOneModal } from '../../components/modals/CreateRiderProfileStepOneModal'
import { CreateRiderProfileStepTwoModal } from '../../components/modals/CreateRiderProfileStepTwoModal'
import { CustomScoringModal } from '../../components/modals/CustomScoringModal'
import JudgingLicenceInformation from '../../components/modals/JudgingLicenceInformation'
import { MakeScoreCardPublicModal } from '../../components/modals/MakeScoreCardPublicModal'
import NewTransferModal from '../../components/modals/NewTransferModal'
import RegistrationHorseModal from '../../components/modals/RegistrationHorseModal'
import RegistrationPeopleModal from '../../components/modals/RegistrationPeopleModal'
import RemoveHorseModel from '../../components/modals/RemoveHorseModel'
import DeleteImageModal from '../../components/modals/RemoveImageModal'
import { ResultsLockedModal } from '../../components/modals/ResultsLockedModal'
import { ScratchFullEntryModal } from '../../components/modals/ScratchFullEntryModal'
import SearchHorseByName from '../../components/modals/SearchHorseByName'
import { SwitchHorse } from '../../components/modals/SwitchHorse'
import { UpdateTeamDetails } from '../../components/modals/UpdateTeamDetails'
import { UpdateUserNumberModal } from '../../components/modals/UpdateUserNumberModal'
import { UserCardModal } from '../../components/modals/UserCardModal'
import UserEmailUpdate from '../../components/modals/UserEmailUpdate'
import SwitchAccounts from '../../components/modals/authenticationModalComponent/SwitchAccounts'
import OrganizerEmailInfo from '../../components/modals/common/OrganizerEmailInfo'
import { AddMembershipModal } from '../../components/modals/membership/AddMembershipModal'
import { CancelMembershipModal } from '../../components/modals/membership/CancelMembershipModal'
import { JoinModal } from '../../components/modals/membership/JoinModal'
import { PauseRenewMembershipModal } from '../../components/modals/membership/PauseRenewMembershipModal'
import { PurchaseMembershipModal } from '../../components/modals/membership/PurchaseMembershipModal'
import ManageStripeAccountModal from '../../components/user/views/profile/Tabs/profile-root-page-finance-tab/modals/ManageStripeConnectAccountModal'
import ConfirmRemoveModal from '../../components/user/views/profile/modals/ConfirmRemoveModal'
import MembersEventModal from '../../pages/messages/modals/MembersEventModal'
import MembersModal from '../../pages/messages/modals/MembersModal'
import { CancelEventConfirmationModal } from '../../pages/organizer/manage/common/modals/CancelEventConfirmationModal'
import { PublishNotificationsModal } from '../../pages/organizer/manage/common/modals/PublishNotificationsModal'
import { PublishOperationsModal } from '../../pages/organizer/manage/common/modals/PublishOperationsModal'
import SpectatorTicketReceiptModal from '../../pages/organizer/manage/revenue/spectator/modals/SpectatorTicketReceiptModal'
import ScratchStaffModal from '../../pages/organizer/staffProfile/modals/ScratchStaffModal'
import TicketBuyerDetailsModal from '../../pages/ticket-dashboard/components/tabs/modals/TicketBuyerDetailsModal'
import TicketBuyerDetailsModalCompSide from '../../pages/ticket-dashboard/components/tabs/modals/TicketBuyerDetailsModalCompSide'
import { RiderInfoModal } from '../../components/modals/InfoModals/RiderInfoModal/RiderInfoModal'
import { RegistrarInfoModal } from '../../components/modals/InfoModals/RegistrarInfoModal/RegistrarInfoModal'
import { CheckDetailsModal } from '../../components/modals/CheckDetailsModal'
import { ConnectBankAccount } from '../../components/modals/ConnectBankAccount'
import { AddTickets } from '../../components/modals/AddTickets'
import { AddFees } from '../../components/modals/AddFees'
import { AddClasses } from '../../components/modals/AddClasses'
import { PayAll } from '../../components/modals/PayAll'
import { SwitchTeamMember } from '../../components/modals/SwitchTeamMember'

// Types
type IProps = {
  modalsState: { [x: string]: boolean }
  dataToPassOn: any
  handleModal: (showHide: boolean, typeOfModal: string, data?: any) => void
}

const MainLayoutModals = (props: IProps) => {
  // Hooks and vars
  const location = useLocation()
  const eventId = location.pathname.includes('events-details')
    ? location.pathname.split('/')[2]
    : null
  const { modalsState, dataToPassOn, handleModal } = props

  return (
    <>
      {modalsState?.[MODAL_CONSTS.SEE_MORE] && (
        <ViewModal show={true} dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.VIEW_SCHEDULE_ORGANIZER] && (
        <EventSchedulingViewScheduleModal
          show={true}
          dataToPassOn={dataToPassOn}
          handleModal={handleModal}
        />
      )}

      {modalsState?.[MODAL_CONSTS.HANDLE_LEGAL_CLAUSE] && (
        <ProfileLegalClauseModal
          show={true}
          dataToPassOn={dataToPassOn}
          handleModal={handleModal}
        />
      )}

      {modalsState?.[MODAL_CONSTS.FORGOT_PASSWORD] && (
        <ForgotPassword show={true} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.SIGN_DOCUMENT] && (
        <SignDocumentModal dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.SHARE_DOCUMENT] && (
        <ShareDocumentModal
          show={true}
          dataToPassOn={dataToPassOn}
          handleModal={handleModal}
          eventId={eventId}
        />
      )}

      {modalsState?.[MODAL_CONSTS.HORSE] && (
        <UserProfileHorseTabAddHorse show={true} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.VENDOR_SPONSOR_INVITATIONS] && (
        <UserSearchModal dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.VENDOR_SPONSOR_INVITATIONS_VIA_MAIL] && (
        <SendEmailModal dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.SUCCESS] && (
        <SuccessModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.TICKET_BUYER_DETAILS] && (
        <TicketBuyerDetailsModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.TICKET_BUYER_DETAILS_COMPSIDE] && (
        <TicketBuyerDetailsModalCompSide handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.RESULTS_LOCKED] && (
        <ResultsLockedModal dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}
      {modalsState?.[MODAL_CONSTS.AUTO_ASSIGN_MODAL] && (
        <AutoAssignModal dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.SCORING] && <ScoringModal dataToPassOn={dataToPassOn} />}

      {modalsState?.[MODAL_CONSTS.CUSTOM_SCORING] && (
        <CustomScoringModal dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.VENDOR_SPONSOR_INVITATIONS] && (
        <UserSearchModal dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.SPECTATOR_TICKET_RECEIPT] && (
        <SpectatorTicketReceiptModal dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.UPDATE_DISCIPLINE] && (
        <UpdateDisciplineModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.REVIEW_ANNEX] && (
        <ReviewAnnex show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.MANAGE_EVENT_MODAL] && (
        <ManageEventModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.MANAGE_STRIPE_CONNECT_ACCOUNT] && (
        <ManageStripeAccountModal
          show={true}
          dataToPassOn={dataToPassOn}
          handleModal={handleModal}
        />
      )}

      {modalsState?.[MODAL_CONSTS.SWITCH_ACCOUNT] && (
        <SwitchAccounts show={true} dataToPassOn={dataToPassOn} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.TICKETS_DISTRIBUTER_MODAL] && (
        <TicketsDistributionModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.LINEAGE_ADDING_HORSES] && (
        <LineageHorseAdd show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.EXHIBITOR_SCRATCH_CONFIRM_MODAL] && (
        <ExhibitorScratchConfirmModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.TEAM_MEMBER_ROLE_CHANGE_WARNING] && (
        <HorseTeamMemberRoleChangeConfirmation
          show={true}
          dataToPassOn={dataToPassOn}
          handleModal={handleModal}
        />
      )}

      {modalsState?.[MODAL_CONSTS.UPLOAD_EVENT_IMAGES] && (
        <UploadEventImagesModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.FORGOT_PASSWORD] && (
        <ForgotPassword show={true} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.MEMBERSHIP_ADD] && (
        <ProfileLegalClauseMembershipModal show={true} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.MEMBERSHIP_MANAGE] && (
        <ProfileLegalClauseManageMembershipModal show={true} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.REMOVE_CONFIRMATION] && (
        <ListRemoveModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.UPDATE_DISCIPLINE] && (
        <UpdateDisciplineModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.PUBLISH_OPERATIONS_MODAL] && (
        <PublishOperationsModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.PUBLISH_NOTIFICATIONS_MODAL] && (
        <PublishNotificationsModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.TEAM] && (
        <UserProfileTeamTabAddTeamMember handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.TEAM_MEMBER_ROLE_CHANGE_WARNING] && (
        <HorseTeamMemberRoleChangeConfirmation
          show={true}
          dataToPassOn={dataToPassOn}
          handleModal={handleModal}
        />
      )}

      {modalsState?.[MODAL_CONSTS.SPECTATOR_TICKETS] && (
        <EventDetailViewComponentSpectatorTicketsModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.BILL_BRIEFE] && (
        <BillDetailsModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.CLOSE_EVENT_CONFIRMATION] && (
        <CloseEventConfirmationModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.CANCEL_EVENT_MODAL] && (
        <CancelEventConfirmationModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.NEW_TRANSFER] && <NewTransferModal dataToPassOn={dataToPassOn} />}

      {modalsState?.[MODAL_CONSTS.CONFIRM_REMOVE_DRAFT_EVENT] && (
        <ConfirmRemoveDraftEventModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}
      {modalsState?.[MODAL_CONSTS.CONFIRM_REMOVE_IMAGE] && (
        <DeleteImageModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.JUDGING_LICENCE] && (
        <JudgingLicenceInformation
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.ACCOUNT_PRIVACY] && (
        <AccountPrivacyInformation
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.REGISTRATION_PEOPLE] && (
        <RegistrationPeopleModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.REGISTRATION_HORSES] && (
        <RegistrationHorseModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.CONFIRM_REMOVE_MODAL] && (
        <ConfirmRemoveModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.UPDATE_PROFILE_EMAIL] && (
        <UserEmailUpdate show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.VIDEO_PLAYER] && (
        <VideoPlayer show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.REMOVE_HORSE] && (
        <RemoveHorseModel show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.SEARCH_HORSE_BY_NAME] && (
        <SearchHorseByName show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.OPEN_ORGANIZER_MAIL_INFO] && (
        <OrganizerEmailInfo show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.SCRATCH_STAFF_MODAL] && (
        <ScratchStaffModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.REGISTER_TEAM] && (
        <RegistrationTeamTabModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.ADD_TEAM_MEMBER_TO_PAPERWORK_STEP_1] && (
        <AddTeamMemberToPaperworkStep1 dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.ADD_TEAM_MEMBER_TO_PAPERWORK_STEP_2] && (
        <AddTeamMemberToPaperworkStep2 dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.UPDATE_USER_NUMBER] && (
        <UpdateUserNumberModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.UPDATE_TEAM_DETAILS] && (
        <UpdateTeamDetails handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.ADD_NEW_TEAM_MEMBER] && (
        <AddNewTeamMemberModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.CREATE_NEW_TEAM_MEMBER_PAPERWORK] && (
        <CreateNewTeamMemberPaperworkModal
          show={true}
          handleModal={handleModal}
          dataToPassOn={dataToPassOn}
        />
      )}

      {modalsState?.[MODAL_CONSTS.ADD_NEW_USER] && (
        <AddNewUserModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.ADD_NEW_HORSE_MEMBER] && (
        <AddNewHorseModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.AI_RULE_BOOK] && (
        <AiRuleBookModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.SWITCH_HORSE] && (
        <SwitchHorse show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.BULK_ADD] && (
        <BulkAdd show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.CLASS_MORE] && (
        <ClassMore show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.ADD_MEMBERSHIP] && (
        <AddMembershipModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.JOIN] && (
        <JoinModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.PURCHASE_MEMBERSHIP] && (
        <PurchaseMembershipModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.CANCEL_MEMBERSHIP] && (
        <CancelMembershipModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.PAUSE_RENEW_MEMBERSHIP] && (
        <PauseRenewMembershipModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.HORSE_ADD_CERTIFICATE] && (
        <AddCertificateModal
          handleCloseModal={() => handleModal(false, MODAL_CONSTS.HORSE_ADD_CERTIFICATE)}
          dataToPassOn={dataToPassOn}
        />
      )}
      {modalsState?.[MODAL_CONSTS.MEMBERS_EVENT_MODAL] && (
        <MembersEventModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.MEMBERS_MODAL] && (
        <MembersModal show={true} handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.SCRATCH_FULL_ENTRY] && (
        <ScratchFullEntryModal dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.CONFIRM_SCRATCH_FULL_ENTRY] && (
        <ConfirmScratchFullEntryModal dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.CREATE_RIDER_PROFILE_STEP_1] && (
        <CreateRiderProfileStepOneModal handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.CREATE_RIDER_PROFILE_STEP_2] && (
        <CreateRiderProfileStepTwoModal handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.CONFIRM_PROFILE_DETAILS] && (
        <ConfirmProfileDetails handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.USER_CARD] && (
        <UserCardModal show={true} handleModal={handleModal} />
      )}

      {modalsState?.[MODAL_CONSTS.ADD_SCORE_CARD] && (
        <AddScoreCardModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.MAKE_SCORE_CARD_PUBLIC] && (
        <MakeScoreCardPublicModal handleModal={handleModal} dataToPassOn={dataToPassOn} />
      )}

      {modalsState?.[MODAL_CONSTS.RIDER_INFO] && <RiderInfoModal dataToPassOn={dataToPassOn} />}

      {modalsState?.[MODAL_CONSTS.REGISTRAR_INFO] && (
        <RegistrarInfoModal dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.CHECK_DETAILS] && (
        <CheckDetailsModal dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.CONNECT_BANK_ACCOUNT] && (
        <ConnectBankAccount dataToPassOn={dataToPassOn} />
      )}
      {modalsState?.[MODAL_CONSTS.ADD_TICKETS] && <AddTickets dataToPassOn={dataToPassOn} />}
      {modalsState?.[MODAL_CONSTS.ADD_FEES] && <AddFees dataToPassOn={dataToPassOn} />}
      {modalsState?.[MODAL_CONSTS.ADD_CLASSES] && <AddClasses dataToPassOn={dataToPassOn} />}
      {modalsState?.[MODAL_CONSTS.PAY_ALL] && <PayAll dataToPassOn={dataToPassOn} />}
      {modalsState?.[MODAL_CONSTS.SWITCH_TEAM_MEMBER] && (
        <SwitchTeamMember dataToPassOn={dataToPassOn} />
      )}
    </>
  )
}

export default MainLayoutModals
